import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import {ApiInteractionRequiredError, acquireTokenSilent, notifyApiInteractionRequired} from "../services/authService";


const backendURL = process.env.REACT_APP_API_URL || 'https://localhost:8081'
const backendURLOld = process.env.REACT_APP_API_URL_NEW || 'http://localhost:18080'
const prepareApiHeaders = async (headers: Headers, endpoint: string) => {
    if (endpoint === "authenticate") {
        return headers;
    }

    try {
        headers.set("Authorization", `Bearer ${await acquireTokenSilent()}`);
    } catch (error) {
        if (error instanceof ApiInteractionRequiredError) {
            notifyApiInteractionRequired();
            return headers;
        }
        throw error;
    }
    return headers;
};

const baseQueryOld = fetchBaseQuery({
    baseUrl: backendURLOld,
    prepareHeaders: (headers, { endpoint }) => prepareApiHeaders(headers, endpoint)
});

const baseQuery = fetchBaseQuery({
    baseUrl: backendURL,
    prepareHeaders: (headers, { endpoint }) => prepareApiHeaders(headers, endpoint)
});

const retryWithFreshToken = async (
    execute: typeof baseQuery,
    args: string | FetchArgs,
    api: Parameters<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>>[1],
    extraOptions: Parameters<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>>[2]
) => {
    let result = await execute(args, api, extraOptions);
    if (result.error?.status !== 401) {
        return result;
    }

    try {
        await acquireTokenSilent(true);
        result = await execute(args, api, extraOptions);
        if (result.error?.status === 401) {
            notifyApiInteractionRequired();
        }
    } catch (error) {
        if (error instanceof ApiInteractionRequiredError) {
            notifyApiInteractionRequired();
        }
    }
    return result;
};


export const OldBaseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
    async (args, api, extraOptions) => {
        return retryWithFreshToken(baseQueryOld, args, api, extraOptions);
    }

export const BaseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
    async (args, api, extraOptions) => {
        return retryWithFreshToken(baseQuery, args, api, extraOptions);
    }

const backendURLOrders = process.env.REACT_APP_API_URL_ORDERS || 'http://localhost:18082'
const baseQueryOrders = fetchBaseQuery({
    baseUrl: backendURLOrders,
    prepareHeaders: (headers, { endpoint }) => prepareApiHeaders(headers, endpoint)
});

export const OrdersBaseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
    async (args, api, extraOptions) => {
        return retryWithFreshToken(baseQueryOrders, args, api, extraOptions);
    }
